import '../../scss/arcade/powerForce.scss';
import Arcade from '../engine/arcade/arcade';
import { capitalize, getSearchParam } from '../util/utilities';

const arcadeName = 'PowerForce';
const utmSource = getSearchParam('utm_source') || '';
const contentUrl = encodeURI(`/powerForce/json/arcadeData${capitalize(utmSource)}.json`);

new Arcade({ arcadeName, contentUrl }).isReady.then((arcade) =>
	console.info(`[Arcade Loaded][${arcade.arcadeState.get('arcadeName')}]`),
);
